import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import styles from '../../styles/account/AccountInfo.module.scss';
import {Col, Button} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faFileAlt } from '@fortawesome/free-solid-svg-icons';


const DashboardItem = (props) => {
    const {details} = props;

    return (
        <Col className={`p-3 mb-3`} xs={12} md={6}>
            <div className={`${styles.infoBox} ${styles.dash} h-100 text-center p-3`}>
                <div className={`${styles.title} mb-0 text-center`} >{details.title}</div>
                <Link href={details.link} title={details.title}>

                    {
                        details.type == 'image' ?
                        <Image layout="fixed" src={details.thumb} alt={details.title} width={details.width} height={details.height} className={styles.imgLink} />
                        :           
                        <FontAwesomeIcon icon={details.thumb} height="32" with="32" size="3x" className="green"/>            
                    }

                </Link>
                
                <div className={`${styles.itemInfo} text-start`}>
                    {details.info}
                </div>
                <p className="mb-0">
                    <Link href={details.link} title={details.title} className={styles.itemDetails}>

                        <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="me-2"/>Detalii
                                                
                    </Link>
                </p>
            </div>
        </Col>
    );
}

export default DashboardItem;